'use strict';

/**
 * View for rendering the list item of photobox albums
 *
 * @category   View
 * @module     collection.album
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ColidoItemView = require('base/Colido.ItemView');

var template = require('../../templates/partials/list-item-unused.hbs');

var ListItemUnusedView = ColidoItemView.extend({
    template: template,

    wrapItem: false,

    ui: {
        imageWrapper: 'li',
        actionDeleteUnused: '[data-action="delete-unused"]',
    },

    events: {
        'click @ui.imageWrapper': 'imageClicked',
        'click @ui.actionDeleteUnused': 'actionDeleteUnused',
    },

    modelEvents: {
        'change': 'render',
    },

    imageClicked: function(event) {
        var $curTarget = $(event.currentTarget);
        this.model.markImage($curTarget.data('imageidx'));
    },

    actionDeleteUnused: function(event) {
        if (window.confirm('Delete all pictures in this album?')) {
            var imageIds = _.pluck(this.model.get('images'), 'id');
            if (imageIds.length) {
                var action = App.getApiUrl('/assets') + '/' + imageIds.join(',');
                $.ajax(action, {
                    type: 'DELETE',
                });
            }

            // Destroy in frontend
            this.model.destroy({});
        }
    },
});

module.exports = ListItemUnusedView;